export const golfEs = {
  golf: {
    title: "Gestión de Campo de Golf",
    subtitle: "Monitorización profesional de césped • Estándares USGA/GCSAA",
    zonesRegistered: "{{count}} zona(s) registrada(s)",
    courseDiary: "Diario del Campo",
    exportReport: "Exportar Informe",
    generatingReport: "Generando...",
    addGolfZones: "Añadir Zonas de Golf",
    noZonesTitle: "No hay zonas de golf añadidas",
    noZonesDesc: "Añade las zonas de tu campo de golf (Greens, Calles, Tees, Rough) como parcelas para comenzar la monitorización con datos satelitales reales, optimización de riego y modelos de riesgo de enfermedades.",
    cropTypeHint: "Al añadir parcelas, selecciona uno de estos tipos de cultivo:",
    loadingData: "Cargando datos del campo de golf...",
    // KPIs
    turfScore: "Turf Score™",
    greenSpeed: "Green Speed (ft)",
    stimpeterEst: "Estimación Stimpmeter",
    noGreensData: "Sin datos de greens",
    avgMoisture: "Humedad Media",
    compactionAlerts: "Alertas de Compactación",
    diseaseWatch: "Vigilancia de Enfermedades",
    // Alerts
    superintendentAlert: "Alerta del Superintendente:",
    compactionHighRec: "— alto riesgo de compactación detectado. Se recomienda aireación.",
    diseasePressureHigh: "— alta presión de enfermedades.",
    noSatelliteTitle: "Aún no hay datos de análisis satelital.",
    noSatelliteDesc: "Ejecuta un análisis satelital en tus parcelas para obtener métricas de NDVI, humedad y riesgo.",
    // Tabs
    zoneOverview: "Resumen de Zonas",
    irrigationPlan: "Plan de Riego",
    turfHealth: "Salud del Césped",
    maintenanceLog: "Registro de Mantenimiento",
    trends: "Tendencias",
    // Zone cards
    ndviPending: "NDVI: pendiente",
    moisturePending: "Humedad: pendiente",
    compaction: "Compactación",
    disease: "Enfermedad",
    // Irrigation tab
    irrigationSchedule: "Programa de Riego",
    irrigationEmptyDesc: "Ejecuta el Optimizador de Riego en tus zonas de golf para generar programas basados en FAO-56.",
    goToIrrigation: "Ir al Optimizador de Riego",
    waterEfficiency: "Eficiencia del Uso del Agua",
    waterEfficiencyEmpty: "Las métricas de eficiencia hídrica aparecerán cuando se calculen los planes de riego para tus zonas.",
    // Health tab
    diseasePressure: "Monitor de Presión de Enfermedades",
    diseasePressureDesc: "Basado en modelos GDD del motor pest-disease-risk-v3",
    noDisease: "No se detectaron alertas de enfermedades. Ejecuta un análisis satelital para actualizar los modelos de riesgo.",
    nutrientStatus: "Estado Nutricional",
    nutrientStatusDesc: "Seguimiento mediante módulo de Fertilización",
    nutrientEmpty: "Los datos de seguimiento nutricional se completarán desde el módulo de Fertilización cuando se registren actividades de campo.",
    goToFertilization: "Ir a Fertilización",
    // Maintenance tab
    superintendentLog: "Diario del Campo — Registro del Superintendente",
    superintendentLogDesc: "Registra tareas diarias de mantenimiento y observaciones",
    noMaintenance: "Aún no hay entradas de mantenimiento. Usa el Cuaderno de Campo para registrar las actividades diarias.",
    openFieldNotebook: "Abrir Cuaderno de Campo",
    // Grass info
    grassSpecies: "Especies de Césped y Parámetros de Gestión",
    grassSpeciesDesc: "Valores de referencia USGA/GCSAA para los tipos de zona registrados",
    cutHeight: "Altura de corte",
    nMax: "N máx",
    // Trends tab
    trendsTitle: "Tendencias NDVI y Humedad",
    trendsDesc: "Evolución histórica desde datos satelitales (últimos 90 días)",
    noTrendsData: "Ejecuta análisis satelitales a lo largo del tiempo para ver datos de tendencia aquí.",
    ndvi: "NDVI",
    moisture: "Humedad (%)",
    // Risk levels
    riskLow: "bajo",
    riskMedium: "medio",
    riskHigh: "alto",
    // Zone types
    greens: "Greens",
    fairways: "Calles",
    teeBoxes: "Tees",
    rough: "Rough",
    // PDF Report
    reportTitle: "Informe de Gestión del Campo de Golf",
    reportGenerated: "Generado",
    reportZoneSummary: "Resumen de Zonas",
    reportGrassParams: "Parámetros de Césped y Gestión",
    reportDisclaimer: "Informe generado por Sentinel Crop. Turf Score™ y Green Speed son estimaciones basadas en datos satelitales y meteorológicos.",
  }
};
